import { combineReducers, createReducer } from '@reduxjs/toolkit';
import { keyBy } from '@mews/fp';
import { fetchServiceAvailabilitySucceeded } from '../serviceAvailability/reducer';

const serviceCategoryMappingsSlice = createReducer({}, (builder) => {
    builder.addCase(fetchServiceAvailabilitySucceeded, (state, { payload: { categoryMappings, serviceId } }) => ({
        ...state,
        [serviceId]: keyBy('resourceCategoryId', categoryMappings),
    }));
});

export const serviceCategoryMappingsReducer = combineReducers({
    data: serviceCategoryMappingsSlice,
});
